import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React, { Component } from "react";
import Modal from "../../../../utils/customModal";
import { getSpk } from "../../../../../Redux/reducer/env";
import * as instanceActions from "../../../../../Redux/api";
import { encryptPassword } from "../../../../utils/functions";
import { successModal, loadingHtml, errorContainer } from "../../../../utils/functions";
import StepControl from "./stepControl";
import QuestionsComponent from "../../../questions";

import ShowBtn from "../../../../../../static/images/show-blue.svg";

export class Step4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
      hiddenInputs: {
        secretWord: true,
        q1: true,
        q2: true,
        q3: true,
      }
    };
  }

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;

    switch (type) {
      case "loading":
        return loadingHtml();
      case "success":
        return successModal(modalMessage.message);
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          this.closeModal
        );
    }
  };

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
    window.location = `/landing`;
  };

  finishAutoenrollment = () => {
    const { modal } = this.state;
    const { instance: { instanceAction } } = this.props;

    modal.show = true;
    this.setState({ modal });

    const data = {
      authCode: this.props.registerInfo.authCode,
      refCode: this.props.registerInfo.refCode,
      newCodUser: encryptPassword(this.props.user.username, this.props.spk),
      usrAccess: encryptPassword(this.props.user.key, this.props.spk),
      usrAccessConfirmation: encryptPassword(this.props.user.confirm_key, this.props.spk),
      secretWord: encryptPassword(
        this.props.user.secretWord,
        this.props.spk
      ),
      secretWordConfirmation: encryptPassword(
        this.props.user.confirmSecretWord,
        this.props.spk
      ),
      answers: [
        {
          idQuestion: this.props.user.questions.question1.id,
          answer: encryptPassword(
            this.props.user.questions.question1.resp,
            this.props.spk
          ),
        },
        {
          idQuestion: this.props.user.questions.question2.id,
          answer: encryptPassword(
            this.props.user.questions.question2.resp,
            this.props.spk
          ),
        },
        {
          idQuestion: this.props.user.questions.question3.id,
          answer: encryptPassword(
            this.props.user.questions.question3.resp,
            this.props.spk
          ),
        },
      ],
    };

    return instanceAction(
      `/self-enrollment/save/${
        window.location.pathname === "/credentials/reset" ? true : false
      }`,
      "put",
      data
    )
      .then(() => {
        modal.type = "success";
        modal.modalMessage.message =
          window.location.pathname === "/credentials/reset"
            ? "¡Recuperación de credenciales exitoso!"
            : "¡Registro de usuario exitoso!";
        this.setState({ modal });
      })
      .catch((err) => {
        if (
          err.response !== undefined &&
          Array.isArray(err.response.data.notifications)
        ) {
          const notification = err.response.data.notifications[0];
          modal.modalMessage = {
            title: notification.message,
            message: notification.description,
          };
        }
        modal.type = "error";
        this.setState({ modal });
      });
  };

  render() {
    const { modal, hiddenInputs } = this.state;
    return (
      <div id="step-4">
        <div className="user-credentials fix-user-credentials">
          <h1>
            Verifique los datos de su registro de usuario antes de continuar
          </h1>
          <div className="user-data">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                {this.props.spk !== undefined && this.props.spk !== "" && window.location.pathname === "/register/auto-enrolment" && (
                <>
                  <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                      <div className="d-flex flex-row item-line">
                        <div className="item item-fix">
                          <h3>Nombre</h3>
                          <p>{this.props.registerInfo !== undefined && this.props.registerInfo.firstName}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                      <div className="d-flex flex-row item-line">
                        <div className="item">
                          <h3>Apellido</h3>
                          <p>{this.props.registerInfo !== undefined && this.props.registerInfo.lastName}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                      <div className="d-flex flex-row item-line">
                        <div className="item item-fix">
                          <h3>Usuario</h3>
                          <p>{this.props.user.username}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                      <div className="d-flex flex-row item-line">
                        <div className="item">
                          <h3>Contraseña <img src={ShowBtn} alt="ver" onClick={() => this.setState({ hiddenInputs: { ...hiddenInputs, secretWord: !hiddenInputs.secretWord } })} /></h3>
                          <p>{ hiddenInputs.secretWord ? '••••••••••' : this.props.user.key}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </>)}
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item item-fix">
                        <h3>Palabra secreta</h3>
                        <p>{this.props.user.secretWord}</p>
                      </div>
                      {/* <div className="item ml-auto item-btn">
                        <img src={`/static/${EditBtn}`} alt="Editar" />
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item item-fix">
                        <h3>Pregunta secreta #1</h3>
                        {this.props.user.questions.question1 !== undefined && (
                          <QuestionsComponent
                            name="question1"
                            valueAttr={`id`}
                            value={this.props.user.questions.question1.id}
                            readOnly={true}
                            onChange={() => {}}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item">
                        <h3>Respuesta #1 <img src={ShowBtn} alt="ver" onClick={() => this.setState({ hiddenInputs: { ...hiddenInputs, q1: !hiddenInputs.q1 } })} /></h3>
                        <p>{ hiddenInputs.q1 ?
                          '••••••••••' :
                          this.props.user.questions.question1 !== undefined ? this.props.user.questions.question1.resp : ''}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item item-fix">
                        <h3>Pregunta secreta #2</h3>
                        <QuestionsComponent
                          name="question2"
                          valueAttr={`id`}
                          value={
                            this.props.user.questions.question2 !== undefined &&
                            this.props.user.questions.question2.id
                          }
                          readOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item">
                        <h3>Respuesta #2 <img src={ShowBtn} alt="ver" onClick={() => this.setState({ hiddenInputs: { ...hiddenInputs, q2: !hiddenInputs.q2 } })} /></h3>
                        <p>{ hiddenInputs.q2 ?
                          '••••••••••' :
                          this.props.user.questions.question2 !== undefined ? this.props.user.questions.question2.resp : ''
                        }</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item item-fix">
                        <h3>Pregunta secreta #3</h3>
                        <QuestionsComponent
                          name="question3"
                          valueAttr={`id`}
                          value={
                            this.props.user.questions.question3 !== undefined &&
                            this.props.user.questions.question3.id
                          }
                          readOnly={true}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div className="d-flex flex-row item-line">
                      <div className="item">
                        <h3>Respuesta #3 <img src={ShowBtn} alt="ver" onClick={() => this.setState({ hiddenInputs: { ...hiddenInputs, q3: !hiddenInputs.q3 } })} /></h3>
                        <p>{hiddenInputs.q3 ?
                          '••••••••••' :
                          this.props.user.questions.question3 !== undefined ? this.props.user.questions.question3.resp : ''
                        }</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <StepControl
            currentStep={4}
            submitStep={() => this.finishAutoenrollment()}
            goBack={() => this.props.submitStep(false)}
          />
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          showClose={modal.type !== "loading"}
          handleClose={() => this.closeModal()}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

Step4.propTypes = {
  user: PropTypes.object.isRequired,
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    registerInfo: state.sessionInfoReducer.registerInfo,
    spk: getSpk(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(Step4);
